import { render, staticRenderFns } from "./ProjectServices.vue?vue&type=template&id=4364d85f"
import script from "./ProjectServices.vue?vue&type=script&lang=js"
export * from "./ProjectServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports